/**
 * Which files are spreadsheets, for the surfaces that show a static grid
 * instead of a preview.
 *
 * Deliberately NOT in components/previews/StaticFilePreview.tsx beside the card
 * it serves: a module that exports both components and plain helpers loses fast
 * refresh for everything in it (react-refresh/only-export-components).
 */
export const XLSX_EXTENSIONS = new Set(['xlsx', 'xls', 'csv'])

export function isSpreadsheetFile(name?: string, docType?: string): boolean {
  if (docType === 'datasheet' || docType === 'excel') return true
  if (!name) return false
  const ext = name.split('.').pop()?.toLowerCase() ?? ''
  return XLSX_EXTENSIONS.has(ext)
}
